import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material'
import { ReactElement, ReactNode } from 'react'
import { usePagination } from '../../data/pagination/usePagination'
import { DefaultChip } from '../chip/DefaultChip'

type DialogInfoAccordionProps = {
  callouts: (string | React.ReactNode)[]
  title: string
  type: 'success' | 'error' | 'warning'
  icon: ReactElement<string>
  count?: number
  /** Optional element rendered beside the title (e.g. a deep-link). Clicks should not toggle the accordion. */
  titleAction?: ReactNode
}

export type CalloutProps = DialogInfoAccordionProps

export const DialogInfoAccordion = ({ title, callouts, icon, type, count, titleAction }: DialogInfoAccordionProps) => {
  const { itemsInCurrentPage, PaginationControls } = usePagination({ items: callouts, pageSize: 20 })
  const chipCount = count ?? callouts.length
  const isEmpty = callouts.length === 0
  return (
    <Box
      sx={{
        border: 'stroke.default',
        borderColor: 'border.strong',
        borderRadius: (theme) => theme.shape['radius-lg'],
      }}
    >
      <Accordion expanded={isEmpty ? false : undefined}>
        <AccordionSummary expandIcon={isEmpty ? null : <ExpandMore />} sx={{ cursor: isEmpty ? 'default' : 'pointer' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" px={2}>
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="body-medium">{title}</Typography>
              {titleAction}
            </Stack>
            <Box>
              <DefaultChip label={chipCount.toString()} color={type} icon={icon} />
            </Box>
          </Stack>
        </AccordionSummary>
        {!isEmpty && (
          <AccordionDetails>
            <Box component="ul" mt={0} mb={0}>
              {itemsInCurrentPage.map((callout, index) => (
                <Typography key={index} variant="body-regular" component="li" sx={{ pb: 1 }}>
                  {callout}
                </Typography>
              ))}
            </Box>
            <PaginationControls hideIfSinglePage sx={{ mt: 3 }} />
          </AccordionDetails>
        )}
      </Accordion>
    </Box>
  )
}
